import React, { useState } from "react";
import DynamicVerifyModal from "../../../../../components/common/VerifyPopUpScreen";
import BadgesComponent from "../../../../../components/common/Badges";
import { ABDMDetails } from "../../../../../constants";
import './HFRVerify.css';
import RadioButtonComponent from '../../../../../components/common/Radios';
import Button from '../../../../../components/common/Button';

const errorMessage = "Please note, you will not be allowed to save any changes without first changing them in ABDM and then re-validating the same in JANANI.";

type VerifyModalProps = {
    closeVerifyModal:(overwriteFacilityName?: any)=>void;
    facilityVerify: any;
    matchingScore?:any;
    onClickNext?:any;
    action?:string;
  };
  const HFRVerify = ({
      closeVerifyModal,
      facilityVerify,
      matchingScore,
      onClickNext,
      action,
  }: VerifyModalProps) => {
      const [show, setShow] = useState<boolean>(true);
      const [overwriteFacName, setOverwriteFacName] = useState<boolean>(false);
      const handleClose = () => setShow(false);
      // const facilityVerify=ABDMDetails
      
      const isInValid = () => {
        return (action == 'update' || action == 'upgrade') && !overwriteFacName
      } 
      
      const contents=
      <>
         <div className="hfr_verification_popup">
        <BadgesComponent
          className="hfr-over-badge"
          badgeName="Facility Details"
          variant="primary-1"
          badgeType="case5"
        />
        <div className="hfr-overview-details">
          <div>
            <label className="overview-details-label">Health Facility Type</label>
            <div className="overview-details-value">{facilityVerify?.facilityType}</div>
          </div>
          <div>
            <label className="overview-details-label">Ownership</label>
            <div className="overview-details-value">{facilityVerify?.ownership}</div>
          </div>
          <div>
            <label className="overview-details-label">Facility Name</label>
            <div className="overview-details-value">{facilityVerify?.facilityName}</div>
            <div>
            <BadgesComponent
          className="hfr-over-badge"
          badgeName={`Matching score : ${matchingScore} %`}
          variant={matchingScore >= 70 ? 'success': 'danger'}
          badgeType="case5"
        />
            </div>
          </div>
          <div>
            <label className="overview-details-label">Facility Status</label>
            <div className="overview-details-value">{facilityVerify?.facilityStatus}</div>
          </div>
        </div>
      </div>
      <div className="hfr_verification_popup">
        <BadgesComponent
          className="hfr-over-badge"
          badgeName="Location Details"
          variant="primary-1"
          badgeType="case5"
        />
        <div className="hfr-overview-details">
          <div>
            <label className="overview-details-label">State</label>
            <div className="overview-details-value">{facilityVerify?.stateName} - {facilityVerify?.stateLGDCode}</div>
          </div>
          <div>
            <label className="overview-details-label">District Name</label>
            <div className="overview-details-value">{facilityVerify?.districtName} - {facilityVerify?.districtLGDCode}</div>
          </div>
          <div>
            <label className="overview-details-label">Sub-District Name</label>
            <div className="overview-details-value">{facilityVerify?.subDistrictName} - {facilityVerify?.subDistrictLGDCode}</div>
          </div>
          <div>
            <label className="overview-details-label">Village/city/town name </label>
            <div className="overview-details-value">{facilityVerify?.villageCityTownName} - {facilityVerify?.villageCityTownLGDCode}</div>
          </div>
        </div>
        <div className="hfr-overview-details">
          <div>
            <label className="overview-details-label">Address</label>
            <div className="overview-details-value">{facilityVerify?.address}</div>
          </div>
          <div>
            <label className="overview-details-label">Latitude</label>
            <div className="overview-details-value">{parseFloat(facilityVerify?.latitude).toFixed(6)}</div>
          </div>
          <div>
            <label className="overview-details-label">Longitude</label>
            <div className="overview-details-value">{parseFloat(facilityVerify?.longitude).toFixed(6)}</div>
          </div>
          <div>
            <label className="overview-details-label">Pincode</label>
            <div className="overview-details-value">{facilityVerify?.pincode}</div>
          </div>
        </div>
      </div>
      {matchingScore != 100 && <>
        <div className="hfr_verification_popup" style={{ margin: 20 }}>
          <span className="overview-details-value">Do you want to overwrite <b>Facility name</b> in RCH 2.0 from ABDM?</span>
          <div>
            <RadioButtonComponent
              onRadioButtonChange={() => {
                setOverwriteFacName(true);
              }}
              radioName={'Yes'}
              radioButtonGroup={'Group'}
              radioId={'yes'}
          />
          <span style={{ marginLeft: 50 }}>
          <RadioButtonComponent
                onRadioButtonChange={() => {
                  setOverwriteFacName(false);
                }}
                radioName={'No'}
                radioButtonGroup={'Group'}
                radioId={'no'}              
                defaultChecked={true}
          />
          </span>
          </div>
            {isInValid() && <p className="overview-details-value" style={{ color: 'red' }}>{errorMessage}</p>}
        </div>
        <div style={{textAlign:'right', margin: 10}}>
        <Button
          onClick={() => {
            onClickNext(overwriteFacName);
          }}
          id="next"
          buttonName={' Next '}
          colorType={'primary'}
          disabled={isInValid()}
        />
        </div>
        </>}                
      </>
    return (
      <DynamicVerifyModal className={"hfr-verify-modal"} title={"ABDM Details"} closeVerifyModal={() => closeVerifyModal(false)} contents={contents}/>
      );
  };
  
  export default HFRVerify;
  